import React from 'react'
import {Link as RouterLink} from 'react-router-dom'
import {Routes} from '../../common/Routes'
import {Box} from '../../webui/Box'
import {Container} from '../../webui/Container'
import {Link} from '../../webui/Link'
import {Paper} from '../../webui/Paper'
import {LoadingSpinnerContainer} from '../../webui/progress/LoadingSpinnerContainer'
import {Typography} from '../../webui/Typography'
import {AllOrganisationsTable} from './AllOrganisationsTable'
import {useAllOrganisations} from './gql/useAllOrganisations'

interface Props {}

export const AllOrganisations: React.FC<Props> = () => {
  const {data: organisations, loading, error} = useAllOrganisations()
  const [showArchived, setShowArchived] = React.useState(false)

  if (loading) {
    return <LoadingSpinnerContainer />
  }
  if (error) {
    return <div>{error.message}</div>
  }

  const visibleOrganisations = organisations
    .filter((o) => (showArchived ? true : (o.archivedAt ?? null) === null))
    .sort((a, b) => {
      const aArchived = (a.archivedAt ?? null) !== null
      const bArchived = (b.archivedAt ?? null) !== null
      if (aArchived === bArchived) return 0
      return aArchived ? 1 : -1
    })

  return (
    <Container>
      <Box p={2} display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
        <Box>
          <Typography>There are currently {visibleOrganisations.length} organisations!</Typography>

          <Box mt={1}>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                cursor: 'pointer',
              }}
            >
              <input type="checkbox" checked={showArchived} onChange={(e) => setShowArchived(e.target.checked)} />
              <Typography>Show archived Organisations</Typography>
            </label>
          </Box>
        </Box>

        <Box>
          <Link component={RouterLink} to={Routes.ADD_ORGANISATION}>
            Add new organisation
          </Link>
        </Box>
      </Box>

      <Box my={2} display="flex" justifyContent="center">
        <Paper sx={{width: 'max-content', maxWidth: 'none'}}>
          <AllOrganisationsTable organisations={visibleOrganisations} />
        </Paper>
      </Box>
    </Container>
  )
}
